import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { myAccountSelector } from 'state/selectors/account';
import { activeGithubIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import AppRouter from 'common/AppRouter';
import useStorageConfiguration from 'components/hooks/useStorageConfig';
import { syncTeamsOnlySelector } from 'state/selectors/teams';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import get from 'lodash/get';

const DEFAULT_STORAGE_CONFIG = {
  createdAt: moment(),
  isDisplay: true
};

const useSyncTeamsCTA = () => {
  const history = useHistory();
  const account = useSelector(myAccountSelector);
  const activeGithubSensors = useSelector(activeGithubIntegrationsSelector);
  const syncedTeams = useSelector(syncTeamsOnlySelector);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const contributorsAndTeamsSettingsEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.contributorsAndTeamsSettingsEnabled
  });

  const storageConfig = useStorageConfiguration({
    storageKey: LOCAL_STORAGE_KEYS.SYNC_TEAMS_CTA_CONFIG,
    defaultConfig: DEFAULT_STORAGE_CONFIG
  });

  const createdAt = get(storageConfig, 'value.createdAt', moment());
  const isDismissed = !get(storageConfig, 'value.isDisplay');
  const isExpired = moment().diff(createdAt, 'days') > 14;

  const shouldShowCTA =
    contributorsAndTeamsSettingsEnabled &&
    (isAdmin(account) || isSuperUser(account)) &&
    !isDismissed &&
    !isExpired &&
    activeGithubSensors.length > 0 &&
    syncedTeams.length === 0;

  const redirectToTeamsSettings = () =>
    history.push(`${AppRouter.TEAMS_SETTINGS.path}?isOrgSettings=true`);

  const dismissCTA = () =>
    storageConfig.updateConfig({ ...storageConfig.value, isDisplay: false });

  return {
    redirectToTeamsSettings,
    shouldShowCTA,
    dismissCTA
  };
};

export default useSyncTeamsCTA;
